import { Injectable, inject } from "@angular/core";
import { setLoading, setLoadingAndError } from "@datorama/akita";
import { EMPTY, Observable, of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { ApiService } from "../api/api.service";
import { InfoModel } from "../api/info/models/info.model";
import { Accounts } from "../api/jpgrondin/accounts/models/accounts.model";
import { AppStore } from "./app.store";

@Injectable({
    providedIn: "root"
})
export class AppService {
    private readonly api = inject(ApiService);
    private readonly store = inject(AppStore);

    public setShowAlternateRole(showAlternateRole: boolean): void {
        this.store.update({ showAlternateRole });
    }

    public async reset() {
        this.store.reset();
    }

    public loadCurrentAccount(): Observable<Accounts> {
        return this.api.accounts.getAccountInfo().pipe(
            setLoading(this.store),
            // Sequential: GET /account may create the account on first login, so /steps cannot run in parallel.
            switchMap((account) =>
                this.api.accounts.getAccountSteps().pipe(
                    map((steps): Accounts => ({ ...account, ...steps })),
                    // Missing steps degrade to "no step permission"; the session must not be blocked.
                    catchError((error: unknown) => {
                        console.error(error);
                        return of(account);
                    })
                )
            ),
            tap((currentAccount) => this.store.update({ currentAccount }))
        );
    }

    public loadServerState(): Observable<InfoModel> {
        return this.api.info.getInfo().pipe(
            setLoadingAndError(this.store),
            tap((serverState) => this.store.update({ serverState })),
            catchError(() => EMPTY)
        );
    }
}
